import { isTree } from '../components/helpers/datasetHelpers';
import { NavigationTree } from '../types';
import { findNavigationTreeForSelectedAxis } from './breadcrumbs';

const addUnnestedValue = (
    responseData: ResponseDataT,
    field: string,
    value: ResponseDataValueT,
): ResponseDataT => {
    const unestedValue = isTree(value) ? value.value : value;
    return {
        ...responseData,
        [field]: `${unestedValue}::`,
    };
};

const addValue = (
    responseData: ResponseDataT,
    field: string,
    value: ResponseDataValueT,
): ResponseDataT => {
    return {
        ...responseData,
        [field]: value,
    };
};

/**
 * Parse the raw data point to add the navigation tree's field to the point's value.
 * @param {ResponseDataT} point - the raw data point
 * @param {NavigationTree[] | undefined} trees - the navigation trees of the chart dimensions
 * @returns the parsed data point
 */
export const parseRawDataPoint = (
    point: Record<string, ResponseDataValueT>,
    trees: NavigationTree[] | undefined,
): ResponseDataT =>
    Object.entries(point).reduce((acc, [field, value]) => {
        const isTreeField =
            trees && findNavigationTreeForSelectedAxis(field, trees);
        if (isTreeField) {
            return addUnnestedValue(acc, field, value);
        }
        return addValue(acc, field, value);
    }, {});

export const parseRawDataLastBreadcrumbPoint = (
    point: Record<string, ResponseDataValueT>,
    currentNavigationTree: NavigationTree | undefined,
    trees: NavigationTree[] | undefined,
): ResponseDataT =>
    Object.entries(point).reduce((acc, [field, value]) => {
        const isTreeField =
            trees && findNavigationTreeForSelectedAxis(field, trees);
        const isCurrentNavigationTreeField =
            currentNavigationTree &&
            findNavigationTreeForSelectedAxis(field, [currentNavigationTree]);

        if (isTreeField && !isCurrentNavigationTreeField) {
            return {
                ...addUnnestedValue(acc, field, value),
                isParent: 'true',
            };
        }
        return {
            ...addValue(acc, field, value),
            isParent: 'true',
        };
    }, {});
